import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Banner from '../components/Banner'

import portrait from '../assets/images/portrait.jpg'
import carte from '../assets/images/carte.jpg'
import wellness from '../assets/images/wellness.jpg'
import funnytoe from '../assets/images/funnytoe.jpg'
import pic05 from '../assets/images/pic05.jpg'
import facebook from '../assets/images/facebook.jpg'

import yinyang from '../assets/images/yinyang.svg'
import logo from '../assets/images/logo.svg'
import leaf from '../assets/images/leaf.svg'

class HomeIndex extends React.Component {
  render() {
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteDescription = this.props.data.site.siteMetadata.description

    return (
      <div>
        <Helmet>
          <html lang="fr" />
          <title>{siteTitle}</title>
          <meta name="description" content={siteDescription} />
        </Helmet>

        <Banner />

        <section id="two">
          <div className="inner horizontal-flex">
            <div className="vertical-flex">
              <h2 className="accroche"> Equilibre </h2>
              <span className="img main">
                <img src={logo} alt="icone d'une balance'" />
              </span>
            </div>
            <div className="vertical-flex">
              <h2 className="accroche"> Bien-être </h2>
              <span className="img main">
                <img src={leaf} alt="icone de feuilles d'arbres" />
              </span>
            </div>
            <div className="vertical-flex">
              <h2 className="accroche"> Mieux-être </h2>
              <span className="img main">
                <img src={yinyang} alt="icone du yin et du yang" />
              </span>
            </div>
          </div>
        </section>

        <div id="main">
          <section id="one" className="tiles">
            <article style={{ backgroundImage: `url(${portrait})` }}>
              <header className="major">
                <h3>Qui suis-je ?</h3>
              </header>
              <Link to="/qui" className="link primary"></Link>
            </article>
            <article style={{ backgroundImage: `url(${carte})` }}>
              <header className="major">
                <h3>La réflexologie</h3>
              </header>
              <Link to="/reflexologie" className="link primary"></Link>
            </article>
            <article style={{ backgroundImage: `url(${wellness})` }}>
              <header className="major">
                <h3>Les bienfaits</h3>
              </header>
              <Link to="/bienfaits" className="link primary"></Link>
            </article>
            <article style={{ backgroundImage: `url(${funnytoe})` }}>
              <header className="major">
                <h3>Prestations</h3>
              </header>
              <Link to="/prestations" className="link primary"></Link>
            </article>
            <article style={{ backgroundImage: `url(${pic05})` }}>
              <header className="major">
                <h3>Infos / Actus</h3>
              </header>
              <Link to="/infos" className="link primary"></Link>
            </article>
            <article style={{ backgroundImage: `url(${facebook})` }}>
              <header className="major">
                <h3>Facebook</h3>
              </header>
              <a
                href="https://fr-fr.facebook.com/annegarnier.reflexologue/"
                className="link primary"
              ></a>
            </article>
          </section>
        </div>
      </div>
    )
  }
}

export default HomeIndex

export const pageQuery = graphql`
  query PageQuery {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js